import { useQuery } from "react-query";
import axiosInstance from "./axiosInstance";
import { GroupMemberRes } from "../../types/ResType";
import { useAppSelector } from "../../utils/hooks";

export const useConversationMembers = () => {
  const currentConversationData = useAppSelector(
    (state) => state.CurrentConversation,
  );

  const chatId = currentConversationData.chat_id;
  const isGroup = currentConversationData.chat_type === "group";
  const enabled = isGroup && typeof chatId === "number" && chatId > 0;

  return useQuery<GroupMemberRes, Error>(
    ["chat/group-members", chatId],
    async () => {
      const response = await axiosInstance.post<GroupMemberRes>(
        "chat/group-members",
        {
          chat_id: chatId,
        },
      );
      return response.data;
    },
    {
      enabled,
      staleTime: Infinity,
      cacheTime: Infinity,
      retry: false,
    },
  );
};
